"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseGetOrderAddOnsOrderAddOnsInnerToJSON = exports.ResponseGetOrderAddOnsOrderAddOnsInnerFromJSONTyped = exports.ResponseGetOrderAddOnsOrderAddOnsInnerFromJSON = exports.instanceOfResponseGetOrderAddOnsOrderAddOnsInner = void 0;
var runtime_1 = require("../runtime");
var PriceBreakdown_1 = require("./PriceBreakdown");
var ProductType_1 = require("./ProductType");
/**
 * Check if a given object implements the ResponseGetOrderAddOnsOrderAddOnsInner interface.
 */
function instanceOfResponseGetOrderAddOnsOrderAddOnsInner(value) {
    var isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productMFEUrl" in value;
    isInstance = isInstance && "distributionId" in value;
    isInstance = isInstance && "productType" in value;
    isInstance = isInstance && "priceBreakdown" in value;
    return isInstance;
}
exports.instanceOfResponseGetOrderAddOnsOrderAddOnsInner = instanceOfResponseGetOrderAddOnsOrderAddOnsInner;
function ResponseGetOrderAddOnsOrderAddOnsInnerFromJSON(json) {
    return ResponseGetOrderAddOnsOrderAddOnsInnerFromJSONTyped(json, false);
}
exports.ResponseGetOrderAddOnsOrderAddOnsInnerFromJSON = ResponseGetOrderAddOnsOrderAddOnsInnerFromJSON;
function ResponseGetOrderAddOnsOrderAddOnsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productId': json['productId'],
        'productMFEUrl': json['productMFEUrl'],
        'distributionId': json['distributionId'],
        'productType': (0, ProductType_1.ProductTypeFromJSON)(json['productType']),
        'metaData': !(0, runtime_1.exists)(json, 'metaData') ? undefined : json['metaData'],
        'priceBreakdown': (0, PriceBreakdown_1.PriceBreakdownFromJSON)(json['priceBreakdown']),
    };
}
exports.ResponseGetOrderAddOnsOrderAddOnsInnerFromJSONTyped = ResponseGetOrderAddOnsOrderAddOnsInnerFromJSONTyped;
function ResponseGetOrderAddOnsOrderAddOnsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productId': value.productId,
        'productMFEUrl': value.productMFEUrl,
        'distributionId': value.distributionId,
        'productType': (0, ProductType_1.ProductTypeToJSON)(value.productType),
        'metaData': value.metaData,
        'priceBreakdown': (0, PriceBreakdown_1.PriceBreakdownToJSON)(value.priceBreakdown),
    };
}
exports.ResponseGetOrderAddOnsOrderAddOnsInnerToJSON = ResponseGetOrderAddOnsOrderAddOnsInnerToJSON;
